import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-extra-forms',
  templateUrl: './extra-forms.component.html',
  styleUrls: ['./extra-forms.component.scss']
})
export class ExtraFormsComponent implements OnInit {
  // Bileşeninizin TypeScript kodunda bu kısmı ekleyin
  tempValue = 0; // Varsayılan başlangıç değeri 0 veya başka bir değer verilebilir
  radioOpt: string;

  constructor(
    public dataServ: DataService
  ) { }

  ngOnInit() {
  }


  updateValue(field: any, operator: string) {
    this.dataServ.menuItem.form_fields.forEach((item: any) => {
      if (item.id == field.id) {
        if (isNaN(item.value) || item.value === null) {
          item.value = 0;
        }
        if (operator === '+') {
          item.value = item.value + 1;
        } else if (operator === '-') {
          // Daha önce belirttiğiniz gibi -1 değil, 0 olmasını istiyorsanız:
          item.value = item.value === 0 ? 0 : item.value - 1;
        }
      }
    });
  }

  getFieldValue(field: any) {
    if (field.value === null || isNaN(field.value)) {
      return 0;
    } else {
      return field.value;
    }
  }
}
